import { render, staticRenderFns } from "./NewApp.vue?vue&type=template&id=f0aa7028&scoped=true&"
import script from "./NewApp.vue?vue&type=script&lang=js&"
export * from "./NewApp.vue?vue&type=script&lang=js&"
import style0 from "./NewApp.vue?vue&type=style&index=0&id=f0aa7028&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0aa7028",
  null
  
)

export default component.exports